import type { types } from '@boss/boss-client';

import type { FormField } from '../Mappers/FormFieldMapper';

export enum columns {
  ONE_THIRD = 'md:col-span-2',
  TWO_THIRD = 'md:col-span-4',
  ONE_HALF = 'md:col-span-3',
  FULL = 'md:col-span-6',
}

export const coloraStoreOptions = (stores: types.Store[], emptyLabel = '') => {
  const options = stores
    .filter(store => store.storetype === 'Colora')
    .map(store => ({ value: store.id, label: store.name }));

  options.unshift({ value: '', label: emptyLabel });

  return options;
};

export const coloraStoreField = (
  stores: types.Store[],
  preferredShop: string | undefined,
  label: string,
): FormField => ({
  name: 'storeid',
  key: 'storeid',
  type: 'select',
  initialValue: stores.find(store => store.id === preferredShop)?.id,
  options: coloraStoreOptions(stores),
  label,
});
